(function(){
  "use strict";
  function byId(id){ return document.getElementById(id); }

  /* ---------------- MOBILE NAV ---------------- */
  var burger = byId("burgerBtn");
  if(burger){
    burger.addEventListener("click", function(){
      var nav = byId("mobileNav");
      nav.hidden = !nav.hidden;
    });
  }

  function isVisible(el){
    var node = el;
    while(node){
      if(node.hidden) return false;
      node = node.parentElement;
    }
    return true;
  }

  /* ---------------- GENERIC TAB PANELS ----------------
     Any group of buttons sharing [data-tabgroup="X"] with [data-tabkey]
     toggles panels [data-tabgroup-panel="X"] with [data-tabkey] to match. */
  function activateTab(group, key){
    document.querySelectorAll('[data-tabgroup="'+group+'"]').forEach(function(btn){
      btn.setAttribute("aria-selected", btn.getAttribute("data-tabkey") === key ? "true" : "false");
    });
    document.querySelectorAll('[data-tabgroup-panel="'+group+'"]').forEach(function(panel){
      panel.hidden = panel.getAttribute("data-tabkey") !== key;
    });
  }
  window.okimamiActivateTab = activateTab;

  /* ---------------- SORT CONTROLS ----------------
     [data-sort-for="panelId"] select re-orders the visible .product-card
     children of that panel by their data-price attribute. */
  function applySort(panelId, mode){
    var panel = byId(panelId);
    if(!panel) return;
    var cards = Array.prototype.slice.call(panel.querySelectorAll(".product-card"));
    if(mode === "price-asc"){
      cards.sort(function(a,b){ return parseFloat(a.getAttribute("data-price")||0) - parseFloat(b.getAttribute("data-price")||0); });
    } else if(mode === "price-desc"){
      cards.sort(function(a,b){ return parseFloat(b.getAttribute("data-price")||0) - parseFloat(a.getAttribute("data-price")||0); });
    } else {
      cards.sort(function(a,b){ return parseInt(a.getAttribute("data-featured-order")||0,10) - parseInt(b.getAttribute("data-featured-order")||0,10); });
    }
    cards.forEach(function(c){ panel.appendChild(c); });
  }
  document.addEventListener("change", function(e){
    var sortSelect = e.target.closest("[data-sort-for]");
    if(sortSelect){ applySort(sortSelect.getAttribute("data-sort-for"), sortSelect.value); }
  });

  /* ---------------- SCROLL LINKS (data-scroll / data-scroll-route) ---------------- */
  document.addEventListener("click", function(e){
    var backTopBtn = e.target.closest(".back-to-top");
    if(backTopBtn){ window.scrollTo({top:0, behavior:"smooth"}); return; }

    var tabBtn = e.target.closest("[data-tabgroup]");
    if(tabBtn){
      activateTab(tabBtn.getAttribute("data-tabgroup"), tabBtn.getAttribute("data-tabkey"));
      return;
    }

    var scrollLink = e.target.closest("[data-scroll]");
    if(scrollLink){
      var targetId = scrollLink.getAttribute("data-scroll");
      var targetEl = byId(targetId);
      if(targetEl && isVisible(targetEl)){
        e.preventDefault();
        targetEl.scrollIntoView({behavior:"smooth", block:"start"});
      } else {
        var fallbackRoute = scrollLink.getAttribute("data-scroll-route");
        if(fallbackRoute && fallbackRoute !== window.location.pathname){
          window.location.href = fallbackRoute + "#" + targetId;
          return;
        }
        setTimeout(function(){
          var el = byId(targetId);
          if(el) el.scrollIntoView({behavior:"smooth", block:"start"});
        }, 60);
      }
      var mobileNav = byId("mobileNav");
      if(mobileNav) mobileNav.hidden = true;
      return;
    }
  });

  /* If arriving with a #hash target (e.g. from footer Affiliate Program link), scroll to it. */
  document.addEventListener("DOMContentLoaded", function(){
    if(window.location.hash){
      var id = window.location.hash.slice(1);
      var el = byId(id);
      if(el){ setTimeout(function(){ el.scrollIntoView({behavior:"smooth", block:"start"}); }, 120); }
    }
  });

  /* ---------------- PRODUCT DETAIL: format pill + qty + amazon select ----------------
     Amazon buy/select/hint elements are scoped by class + closest panel, not id,
     since a product can have more than one Amazon-only format (paperback + hardcover)
     rendered as sibling panels; duplicate ids would break getElementById lookups. */
  document.addEventListener("click", function(e){
    var pillBtn = e.target.closest("[data-pdformat]");
    if(pillBtn){
      var key = pillBtn.getAttribute("data-pdformat");
      document.querySelectorAll("[data-pdformat]").forEach(function(b){
        b.setAttribute("aria-pressed", b === pillBtn ? "true" : "false");
      });
      document.querySelectorAll("[data-pd-buy-panel]").forEach(function(panel){
        panel.hidden = panel.getAttribute("data-pd-buy-panel") !== key;
      });
      var priceEl = byId("pdPrice");
      var priceHtml = pillBtn.getAttribute("data-price-html");
      if(priceEl && priceHtml){ priceEl.textContent = priceHtml; }
      var hero = byId("pdHero");
      if(hero){
        var flag = hero.querySelector(".format-flag");
        var label = pillBtn.textContent.trim() + " Edition";
        if(flag){ flag.textContent = label; }
      }
      return;
    }

    var qtyBtn = e.target.closest("[data-pdqty]");
    if(qtyBtn){
      var delta = parseInt(qtyBtn.getAttribute("data-pdqty"),10);
      var valEl = byId("pdQtyVal");
      var addBtn = document.querySelector('[data-add-to-cart][data-pd-main]');
      var current = parseInt(valEl.textContent,10) || 1;
      var next = Math.max(1, current + delta);
      valEl.textContent = next;
      if(addBtn) addBtn.setAttribute("data-qty", next);
      return;
    }

    var amazonBtn = e.target.closest(".pd-amazon-btn");
    if(amazonBtn){
      var panel = amazonBtn.closest(".pd-amazon-cta");
      var picker = panel && panel.querySelector(".pd-country-picker");
      var hint = panel && panel.querySelector(".pd-amazon-hint");
      if(picker){ picker.hidden = false; openCountryPanel(picker); }
      if(hint) hint.hidden = false;
      return;
    }

    var countryTrigger = e.target.closest(".pd-country-trigger");
    if(countryTrigger){
      var triggerPicker = countryTrigger.closest(".pd-country-picker");
      var triggerPanel = triggerPicker.querySelector(".pd-country-panel");
      if(triggerPanel.hidden){ openCountryPanel(triggerPicker); } else { closeCountryPanel(triggerPicker); }
      return;
    }

    var countryOption = e.target.closest(".pd-country-list li");
    if(countryOption && !countryOption.hidden){
      selectCountryOption(countryOption.closest(".pd-country-picker"), countryOption);
      return;
    }

    /* Click elsewhere closes any open country picker panels (a product can
       render more than one picker, one per Amazon format) */
    document.querySelectorAll(".pd-country-picker").forEach(function(p){
      if(!p.contains(e.target) && !e.target.closest(".pd-amazon-btn")){ closeCountryPanel(p); }
    });
  });

  document.addEventListener("input", function(e){
    var searchInput = e.target.closest(".pd-country-search-input");
    if(searchInput){ filterCountryList(searchInput.closest(".pd-country-picker"), searchInput.value); }
  });

  document.addEventListener("keydown", function(e){
    if(e.key === "Escape"){
      document.querySelectorAll(".pd-country-picker").forEach(closeCountryPanel);
      return;
    }
    if(e.target.classList && e.target.classList.contains("pd-country-search-input") && e.key === "Enter"){
      e.preventDefault();
      var picker = e.target.closest(".pd-country-picker");
      var first = picker.querySelector(".pd-country-list li:not([hidden])");
      if(first) selectCountryOption(picker, first);
    }
  });

  /* ---- Amazon country picker helpers: flag + searchable list of 13 real
     marketplaces. No ids (a product can render more than one picker side by
     side), so every helper takes the specific .pd-country-picker element. ---- */
  function openCountryPanel(picker){
    var trigger = picker.querySelector(".pd-country-trigger");
    var panel = picker.querySelector(".pd-country-panel");
    var input = picker.querySelector(".pd-country-search-input");
    panel.hidden = false;
    trigger.setAttribute("aria-expanded", "true");
    input.value = "";
    filterCountryList(picker, "");
    setTimeout(function(){ input.focus(); }, 0);
  }
  function closeCountryPanel(picker){
    var trigger = picker.querySelector(".pd-country-trigger");
    var panel = picker.querySelector(".pd-country-panel");
    panel.hidden = true;
    trigger.setAttribute("aria-expanded", "false");
  }
  function filterCountryList(picker, query){
    var q = query.trim().toLowerCase();
    var items = picker.querySelectorAll(".pd-country-list li");
    var visible = 0;
    items.forEach(function(li){
      var match = li.textContent.toLowerCase().indexOf(q) !== -1;
      li.hidden = !match;
      if(match) visible++;
    });
    var empty = picker.querySelector(".pd-country-empty");
    if(empty) empty.hidden = visible !== 0;
  }
  function selectCountryOption(picker, li){
    var trigger = picker.querySelector(".pd-country-trigger");
    var flag = li.querySelector(".pd-country-flag").textContent;
    var name = li.querySelector(".pd-country-name").textContent;
    trigger.querySelector(".pd-country-flag").textContent = flag;
    trigger.querySelector(".pd-country-label").textContent = name;
    picker.querySelectorAll(".pd-country-list li").forEach(function(o){
      o.setAttribute("aria-selected", o === li ? "true" : "false");
    });
    closeCountryPanel(picker);
    var base = picker.getAttribute("data-asin-base");
    var domain = li.getAttribute("data-domain") || "amazon.com";
    window.open("https://www."+domain+"/dp/"+base, "_blank", "noopener");
  }

  /* ---------------- SUCCESS MODALS ---------------- */
  if(byId("successClose")) byId("successClose").addEventListener("click", function(){ byId("successModal").classList.remove("open"); });
  if(byId("affiliateSuccessClose")) byId("affiliateSuccessClose").addEventListener("click", function(){ byId("affiliateSuccessModal").classList.remove("open"); });

  /* Show success modal automatically if Shopify's native form redirected back with a success flag */
  document.addEventListener("DOMContentLoaded", function(){
    var params = new URLSearchParams(window.location.search);
    if(params.get("okimami_newsletter") === "1" && byId("successModal")){ byId("successModal").classList.add("open"); }
    if(params.get("okimami_affiliate") === "1" && byId("affiliateSuccessModal")){ byId("affiliateSuccessModal").classList.add("open"); }
  });
})();
